var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import useTabs from "../../Hooks/useTabs";
import EmailForm, { EMAIL_FORM_DEFAULTS } from "./EmailForm";
import SMSForm from "./SMSForm";
import useService from "../../Hooks/useService";
import MessageTemplateService from "../../../Services/MessageTemplate.service";
import PersonService from "../../../Services/Person.service";
import Loading from "../../UI/Loading/Loading";
import SendMessageAsNoteForm from "./SendMessageAsNoteForm";
import EmailRecipientForm from "./EmailRecipientForm";
import Checkbox from "../../UI/Form/Checkbox";
import useHasPermission from "../../Hooks/useHasPermission";
export const EMAIL_OR_SMS_DEFAULTS = Object.assign(Object.assign({}, EMAIL_FORM_DEFAULTS), { logMessage: false });
const EmailOrSMSForm = (_a) => {
    var { preamble, showOnlyFilters, defaultTab, showRecipientForm, renderAttachments, hideInlineAttachmentsCheckbox } = _a, formValues = __rest(_a, ["preamble", "showOnlyFilters", "defaultTab", "showRecipientForm", "renderAttachments", "hideInlineAttachmentsCheckbox"]);
    const [personalizationMenuState, loadPersonalizationMenus] = useService(MessageTemplateService.getPersonalizationMenus);
    const hasLoggingPermission = useHasPermission("CAN_LOG_MESSAGES");
    const [canITextState, loadCanIText] = useService(PersonService.canIText);
    useEffect(() => {
        loadPersonalizationMenus();
        loadCanIText();
    }, [loadCanIText, loadPersonalizationMenus]);
    const [tabs, content, currentTabIndex] = useTabs({
        tabs: [
            // @ts-expect-error - TS2322 - Type '{ content: (isActive: any) => Element; tab: string; }' is not assignable to type 'false'.
            {
                // eslint-disable-next-line react/display-name
                content: (isActive) => (_jsxs(_Fragment, { children: [showRecipientForm && (_jsx(EmailRecipientForm, Object.assign({ showOnlyPopulations: showOnlyFilters }, formValues, { dontValidate: !isActive }))), _jsx(EmailForm, Object.assign({}, formValues, { personalizationMenus: personalizationMenuState, dontValidate: !isActive, withTemplate: true, hideInlineAttachmentsCheckbox: hideInlineAttachmentsCheckbox }))] })),
                tab: "Email",
            },
            // @ts-expect-error - TS2322 - Type '{ content: (isActive: any) => Element; tab: string; } | null' is not assignable to type 'false'.
            canITextState.data
                ? {
                    // eslint-disable-next-line react/display-name
                    content: (isActive) => (_jsxs(_Fragment, { children: [showRecipientForm && (_jsx(EmailRecipientForm, Object.assign({ showOnlyPopulations: showOnlyFilters }, formValues, { dontValidate: !isActive }))), _jsx(SMSForm, Object.assign({}, formValues, { personalizationMenus: personalizationMenuState, dontValidate: !isActive }))] })),
                    tab: "Text Message",
                }
                : null,
        ],
        tabStyle: "underline",
        keepAllTabsMounted: false,
        defaultTab,
    });
    const { setValue } = formValues;
    useEffect(() => {
        if (currentTabIndex === 0) {
            setValue("isEmail", true, true);
        }
        else {
            setValue("isEmail", false, true);
        }
    }, [currentTabIndex, setValue]);
    // Implemented manually (instead of using <ServiceResult/> because we want to just show the email form if for some reason loading in
    // whether a person has permission to text fails.
    if (canITextState.isLoading) {
        return _jsx(Loading, { isCentered: true, size: "lg" });
    }
    if (!canITextState.data) {
        return (_jsxs(_Fragment, { children: [_jsx("input", { type: "hidden", value: "true", ref: formValues.register, name: "isEmail" }), preamble, showRecipientForm && (_jsx(EmailRecipientForm, Object.assign({ showOnlyPopulations: showOnlyFilters }, formValues))), _jsx(EmailForm, Object.assign({}, formValues, { personalizationMenus: personalizationMenuState, hideInlineAttachmentsCheckbox: hideInlineAttachmentsCheckbox })), renderAttachments || null, hasLoggingPermission && (_jsx("div", { className: "form-group", children: _jsx(Checkbox, { label: "Log Message", name: "logMessage", helpText: "If a student is the recipient of this message, show this message in their Messages and Activity tabs.\n              Logged messages will be stored on the student profile regardless of the delivery status.", ref: formValues.register }) })), _jsx(SendMessageAsNoteForm, Object.assign({}, formValues))] }));
    }
    return (_jsxs(_Fragment, { children: [tabs, _jsx("input", { type: "hidden", 
                // @ts-expect-error - TS2322 - Type 'boolean' is not assignable to type 'string | number | readonly string[] | undefined'.
                value: currentTabIndex === 0, ref: formValues.register, name: "isEmail" }), _jsxs("div", { className: "mt-3", children: [preamble, content, (currentTabIndex === 0 && renderAttachments) || null, hasLoggingPermission && (_jsx("div", { className: "form-group", children: _jsx(Checkbox, { label: "Log Message", name: "logMessage", helpText: "If a student is the recipient of this message, show this message in their Messages and Activity tabs.\n              Logged messages will be stored on the student profile regardless of the delivery status.", ref: formValues.register }) })), _jsx(SendMessageAsNoteForm, Object.assign({}, formValues))] })] }));
};
export default EmailOrSMSForm;
